module.exports = __webpack_public_path__ + "media/icons/offer-details-przod@2x-fdae78c2.png";